import {useState, useEffect} from "react";
import WVLogo from "../../../images/wv-logo.svg"; 
import WVLogoBkR from "../../../images/wv-logo-black-R.jpg";
import WVMBLLogo from "../../../images/wv_mbl_logo.svg";
import WVLogoBkRR from "../../../images/wv-logo-black-R-R.jpg"; 
import WVLogoWHRR from "../../../images/wv-logo-white-RR.png";
import WVLogoFin from "../../../images/finland_logo.png";
import WVLogoJPNO from "../../../images/WorldVision-Logo-Japan.svg";
import WVLogoFinWhite from "../../../images/finland_logo_white.png";
import { Communitylogo, HeaderLogo } from "../Header";
import WVFLogo from "../../../images/wvlogoheader_login_fr.png";
import { isMobile } from "../../../utilities/deviceUtilities";
import { useSelector } from "react-redux";
import { gaEvent } from "../../../utilities/analytics";

export default function Logo(props){
    const [imgSrc, setImgSrc] = useState(null);
    const { persistItemsReducer } = useSelector((state) => state);
    const {handleHomeClick, communityheader, onClicklogo} = props; 
    const handleWVLogo = () => {
        gaEvent("WVLogoBtn_WorldScreen",persistItemsReducer);
        if(onClicklogo){
            onClicklogo();
        }
        if(communityheader == true){
            handleHomeClick();
        }
    }
   
    useEffect(()=>{
        if(props?.soCode == "FRAO"){
            if(props?.communityheader){
                setImgSrc( WVLogoBkR)
            }else{
                setImgSrc( WVFLogo)
            }
        }else if(props?.soCode == "AUTO"){
            if(props?.communityheader){
                if(isMobile(740)){
                    setImgSrc(WVMBLLogo); 
                }
                else{
                    setImgSrc(WVLogoBkR); 
                }
            }else{
                setImgSrc( WVLogo)
            }
        }
        else if(props?.soCode == "JPNO"){
            if(props?.communityheader){
                if(isMobile(740)){
                    setImgSrc(WVMBLLogo); 
                }
                else{
                    setImgSrc(WVLogoJPNO); 
                }
            }else{
                setImgSrc( WVLogo)
            }
        }
        else if(props?.soCode == "FINO"){
            if(props?.communityheader){
                if(isMobile(740)){
                    setImgSrc(WVMBLLogo)
                }
                else{
                    setImgSrc(WVLogoFin); 
                }
            }else{
                setImgSrc( WVLogoFinWhite)
            }
        }else{
            if(props?.communityheader){
                if(isMobile(740)){
                    setImgSrc(WVMBLLogo)
                }else{
                    setImgSrc(WVLogoBkRR); 
                }
            }else{
                setImgSrc(WVLogoWHRR)
            }
        }
 } )
     return(
        <Communitylogo> 
            <HeaderLogo isJPNO={props?.soCode == "JPNO" ? "true" : "false"} src={imgSrc} onClick={handleWVLogo}/>
        </Communitylogo>)
}
